/** Integer USD cents as a bare two-decimal amount (e.g. 1999 -> "19.99"), no currency symbol. */
export function formatUsdAmount(cents) {
    return (cents / 100).toFixed(2);
}
/** Format integer USD cents as a dollar string (e.g. 1999 → "$19.99"). */
export function formatUsd(cents, options) {
    if (options?.group) {
        return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100);
    }
    return `$${formatUsdAmount(cents)}`;
}
//# sourceMappingURL=formatUsd.js.map